module.exports = __webpack_public_path__ + "static/media/Plant Monster.c8303f4f.jpg";